import {
  BrightHorizonsAction,
  BrightHorizonsRedeemCreditsDetail,
  LinkActionActionType,
  LinkActionBh,
} from '@rover/rsdk/src/apiClient/latest';

export const isLinkAction = (action?: BrightHorizonsAction): action is LinkActionBh => {
  return action?.actionType === LinkActionActionType.link;
};

export const isBrightHorizonsRedeemCreditsResponseData = (
  data: unknown
): data is BrightHorizonsRedeemCreditsDetail => {
  return ['message', 'severity', 'event'].every((item) => !!data?.[item]);
};
